import { render, staticRenderFns } from "./TopProceduresWidget.vue?vue&type=template&id=9d9b11b6&scoped=true&"
import script from "./TopProceduresWidget.vue?vue&type=script&lang=js&"
export * from "./TopProceduresWidget.vue?vue&type=script&lang=js&"
import style0 from "./TopProceduresWidget.vue?vue&type=style&index=0&id=9d9b11b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9b11b6",
  null
  
)

export default component.exports